import { render } from "./quotemensaje.vue?vue&type=template&id=2116e5ca&scoped=true"
import script from "./quotemensaje.vue?vue&type=script&lang=js"
export * from "./quotemensaje.vue?vue&type=script&lang=js"

import "./quotemensaje.vue?vue&type=style&index=0&id=2116e5ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2116e5ca"]])

export default __exports__